
  import * as ipxRuntime$_8QWwUX_6FCqNW5lKkc3YG9QPT4r3M6yqxlwRWe3KEbo from '/codebuild/output/src3811682644/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipx']: { provider: ipxRuntime$_8QWwUX_6FCqNW5lKkc3YG9QPT4r3M6yqxlwRWe3KEbo, defaults: {} }
    }
  }
